import React, { FC } from 'react';
import classNames from 'classnames';

interface AppWrapProps {
  className?: string;
  children?: React.ReactNode;
}

const AppWrap: FC<AppWrapProps> = ({ className, children, ...props }) => {
  const compClass = classNames({
    'nk-wrap': true,
    [`${className}`]: className,
  });

  return (
    <div className={compClass} {...props}>
      {children}
    </div>
  );
};

export default AppWrap;
